export default (theme) => ({
    root: {},
    blueBox: {
        height: 168,
        width: '100%',
        backgroundColor: theme.colors.semantic.info400,
        borderRadius: 8,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 16,
        boxSizing: 'border-box',
        padding: 32,
    },
    blueBoxIcon: {
        height: 64,
        width: 64,
        marginBottom: 16,
    },
    blueBoxText: {
        color: theme.colors.primary.white,
    },
    title: {
        marginBottom: 16,
    },
    description: {
        marginBottom: 32,
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 16,
    },
});
